/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserGroupAssignment } from './UserGroupAssignment';
import {
    UserGroupAssignmentFromJSON,
    UserGroupAssignmentFromJSONTyped,
    UserGroupAssignmentToJSON,
    UserGroupAssignmentToJSONTyped,
} from './UserGroupAssignment';

/**
 * 
 * @export
 * @interface CreateUserGroupAssignment201Response
 */
export interface CreateUserGroupAssignment201Response {
    /**
     * 
     */
    data?: UserGroupAssignment;
}

/**
 * Check if a given object implements the CreateUserGroupAssignment201Response interface.
 */
export function instanceOfCreateUserGroupAssignment201Response(value: object): value is CreateUserGroupAssignment201Response {
    return true;
}

export function CreateUserGroupAssignment201ResponseFromJSON(json: any): CreateUserGroupAssignment201Response {
    return CreateUserGroupAssignment201ResponseFromJSONTyped(json, false);
}

export function CreateUserGroupAssignment201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserGroupAssignment201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UserGroupAssignmentFromJSON(json['data']),
    };
}

export function CreateUserGroupAssignment201ResponseToJSON(json: any): CreateUserGroupAssignment201Response {
    return CreateUserGroupAssignment201ResponseToJSONTyped(json, false);
}

export function CreateUserGroupAssignment201ResponseToJSONTyped(value?: CreateUserGroupAssignment201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UserGroupAssignmentToJSON(value['data']),
    };
}

